/**
 * @module SessionStorage
 * @description Session storage utilities for tab-scoped session management
 * @Author: Antigravity AI
 * @Date: 2026-01-30
 */

const SESSION_KEY_STORAGE_KEY = 'SL_SESSION_KEY';

/**
 * Stores session key in sessionStorage (tab-scoped)
 * 
 * @param {string} sessionKey - The session key to store
 */
export const setSessionKey = (sessionKey) => {
    if (!sessionKey) {
        console.warn('Attempted to set empty session key');
        return;
    }

    try {
        sessionStorage.setItem(SESSION_KEY_STORAGE_KEY, sessionKey);
        console.log('Session key stored successfully');
    } catch (error) {
        console.error('Failed to store session key:', error);
    }
};

/**
 * Retrieves session key from sessionStorage
 * 
 * @returns {string|null} Session key or null if not found
 */
export const getSessionKey = () => {
    try {
        const sessionKey = sessionStorage.getItem(SESSION_KEY_STORAGE_KEY);
        return sessionKey;
    } catch (error) {
        console.error('Failed to retrieve session key:', error);
        return null;
    }
};

/**
 * Removes session key from sessionStorage
 */
export const clearSessionKey = () => {
    try {
        sessionStorage.removeItem(SESSION_KEY_STORAGE_KEY);
        console.log('Session key cleared successfully');
    } catch (error) {
        console.error('Failed to clear session key:', error);
    }
};

/**
 * Checks if a session key exists in sessionStorage
 * 
 * @returns {boolean} True if session key exists, false otherwise
 */
export const hasSessionKey = () => {
    try {
        const sessionKey = sessionStorage.getItem(SESSION_KEY_STORAGE_KEY);
        return sessionKey !== null && sessionKey !== undefined && sessionKey !== '';
    } catch (error) {
        console.error('Failed to check session key:', error);
        return false;
    }
};
